<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Category' | translate }}:
    </label>
    <div class="col-sm-9">
      <select class="form-control" [(ngModel)]="selectCategory_id"
        (ngModelChange)="onSelectCategory($event)" name="category"
        required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let category of categories"
          value={{category.id}}>
          <span>{{category.name}}</span>
        </option>
      </select>
    </div>
  </div>
  <div class="form-group" >
    <label class="control-label col-sm-3">
      {{ 'Service' | translate }}:
    </label>
    <div class="col-sm-9">
      <select class="form-control" [ngModel]="editticket.service_id"
        (ngModelChange)="onSelectService($event)" name="service"
        required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let service of services" value={{service.id}}>
          <span>{{service.name}}</span>
        </option>
      </select>

      <div
        class="amounts-panel"
        *ngIf="areAmountsVisible">
        <div class="amount-panel"
          *ngIf="remaining_assistances !== undefined">
          <label class="">
            {{ 'Remaining assistances' | translate }}:
          </label>
          <span class="">
            {{remaining_assistances}}
          </span>
        </div>
        <div class="amount-panel"
          *ngIf="courtesy_assistances !== undefined">
          <label class="">
            {{ 'Courtesy assistance' | translate }}:
          </label>
          <span class="">
            {{courtesy_assistances}}
          </span>
        </div>

        <div class="amount-panel"
          *ngIf="used_services !== undefined">
          <label class="">
            {{ 'Used services' | translate }}:
          </label>
          <span class="">
            {{used_services}}
          </span>
        </div>
        <div class="amount-panel"
          *ngIf="total_cases !== undefined">
          <label class="">
            {{ 'Quantity of cases' | translate }}:
          </label>
          <span class="">
            {{total_cases}}
          </span>
        </div>
 
   
      </div>
         <!--new data-->

    <div *ngIf="areAmountsVisible" class="amounts-panel">
      <div class="amount-panel"
      *ngIf="additionalplanservice.emergency_reporting_time !== null">
      <label class="">
        {{ 'Emergency reporting time' | translate }}:
      </label>
      <span class="">
        {{additionalplanservice.emergency_reporting_time}}h
      </span>
    </div>
    
    
      <div class="amount-panel"
      *ngIf="additionalplanservice.territoriality !== undefined">
      <label class="">
        {{ 'Territoriality' | translate }}:
      </label>
      <span class="">
        {{additionalplanservice.territoriality}}
      </span>
    </div>

      

      <div class="amount-panel"
      *ngIf="additionalplanservice.special_condition !== undefined">
      <label class="">
        {{ 'Special condition/Observations' | translate }}:
      </label>
      <span class="">
        {{additionalplanservice.special_condition}}
      </span>
    </div>

    <div class="amount-panel"
      *ngIf="intime !== undefined">
      <label class="">
       {{'Out of emergency reporting time' | translate}}:
      </label>
      <span class="">
        {{intime}}
      </span>
    </div>

    <div class="amount-panel"
    *ngIf="disponible !== undefined">
    <label class="">
     {{ 'Available' | translate }}:
    </label>
    <span class="">
      {{disponible}}
    </span>
  </div>

  <div class="amount-panel"
  *ngIf="consumido !== undefined">
  <label class="">
   {{ 'Consumed' | translate }}:
  </label>
  <span class="">
    {{consumido}}
  </span>
</div>
  <br>
  </div>
  <!--end new data-->
    </div>
  </div>
  <div *ngIf="showcarflag">
    <div class="form-group" [ngClass]="{'has-error':fieldsRequired['address']}">
      <label class="control-label col-sm-3">
        {{ 'Brand' | translate }}:
      </label>
      <div class="col-sm-9">
          <app-car-brand-search
          #carBrandSearch
          [carBrand] = "brandSelected"
          (onSelect)="onSelectBrand($event)">
        </app-car-brand-search>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Model' | translate }}:
      </label>
      <div class="col-sm-9">
        <input type="text" class="form-control" 
               [(ngModel)]="editticket.model_description" 
               name="model_description" 
               placeholder="{{ 'Model' | translate }}" 
               required>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Year' | translate }}:
      </label>
      <div class="col-sm-9">
        <select class="form-control" [(ngModel)]="selectYear"
          (ngModelChange)="onSelectYear($event)" name="year" required>
          <option [ngValue]="null">---</option>
          <option *ngFor="let year of years"
            value={{year}}>
            <span>{{year}}</span>
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Plate' | translate }}:
      </label>
      <div class="col-sm-9">
        <input
          type="text" class="form-control"
          [(ngModel)]="editticket.car_plate" name="plate" required>
      </div>
    </div>
    <!-- Car Color -->
    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Color' | translate }}:
      </label>
      <div class="col-sm-9">
        <input type="text" class="form-control" [(ngModel)]="editticket.color_description"
          (ngModelChange)="onSelectColor($event)" name="color_description" required>
      </div>
    </div>

  </div>



   <!-- State -->
   <div class="form-group">
    <label class="control-label col-sm-3">
      <span>
        {{(destinationCountry.state_text ? destinationCountry.state_text : 'State' )| translate}}  Destino 
      </span>:
    </label>
    <div class="checkbox col-sm-9">
      <select name="state_id" class="form-control"
        (ngModelChange)="onSelectState($event)"
        [(ngModel)]="editticket.state_id" required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let state of states" [ngValue]="state.id">
          {{ state.name }}
        </option>
      </select>
    </div>
  </div>

  <!-- State District -->
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{
        (destinationCountry.state_district_text ? destinationCountry.state_district_text : 'State District')
        | translate
      }}  Destino:
    </label>
    <div class="col-sm-9">
      <select name="state_district_id" class="form-control"
        [(ngModel)]="editticket.state_area_id" required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let state of statesDistrict" [ngValue]="state.id">
          {{ state.name }}
        </option>
      </select>
    </div>
  </div>

    <div class="form-group">

    <label class="control-label col-sm-3">
      {{ 'Destination Address' | translate }}:
    </label>
    <div class="col-sm-9">
      <textarea
        rows="5" cols="10" class="form-control"
        [(ngModel)]="editticket.address_destination" name="address" required>
      </textarea>
    </div>
  </div>


  <!-- Street -->
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Destination Street' | translate }}:
    </label>
    <div class="col-sm-9">
      <input
        class="form-control" type="text"
        [(ngModel)]="editticket.street_destination" name="street_destination" required>
    </div>
  </div>

  <!-- Suburb -->
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Destination Suburb' | translate }}:
    </label>
    <div class="col-sm-9">
      <input
        class="form-control" type="text"
        [(ngModel)]="editticket.suburb_destination" name="suburb_destination" required>
    </div>
  </div>


  <!-- Postal Code -->
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Destination Postal Code' | translate }}:
    </label>
    <div class="col-sm-9">
      <input
        class="form-control" type="text"
        [(ngModel)]="editticket.postal_code_destination" name="postal_code_destination" required>
    </div>
  </div>


  <ng-container *ngIf = "editservice && editservice.name == 'GASOLINA' ">

    <!-- Liters -->
    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Liters' | translate }}:
      </label>
      <div class="col-sm-9">
        <input
          class="form-control" type="number"
          [(ngModel)]="editticket.liters" name="liters" required>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">{{ 'Gasoline Type' | translate }}:</label>
      <div class="checkbox col-sm-9">
        <select name="gasoline_type" class="form-control"
          [(ngModel)]="editticket.gasoline_type" required>
          <option [ngValue]="null">---</option>
          <option *ngFor="let gasolineType of gasolineTypes" [ngValue]="gasolineType.id">
            {{ gasolineType.name }}
          </option>
        </select>
      </div>
    </div>

  </ng-container>

  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Destination Location' | translate }}:
    </label>
    <div class="col-sm-9">
      <app-select-location
        #selectLocationComp
        [location]="caseLocation" [memberLocation]="memberLocation"
        [ticketstep]="true" [showMap]="showMap" [requireDataLatLng]="true"
        (selectLocation)="step1SetLocation($event)">
      </app-select-location>
    </div>
  </div>

  <div class="form-group">
    <label class="col-sm-3 control-label">
      {{ 'Programmed' | translate }}:
    </label>
    <div class="d-inline col-sm-9 radio-btn-panel">
      <div class="d-inline">
        <input [ngModel]="programmed" name="program" type="radio"
          (click)="onSelectProgram(1)" [value]=1 id="programmed-yes">
        <label for="programmed-yes">
          {{ 'Yes' | translate }}
        </label>
      </div>
      <div class="d-inline" *ngIf="!sale_canceled">
        <input [ngModel]="programmed" name="program" type="radio"
          (click)="onSelectProgram(0)" [value]=0  id="programmed-no">
        <label for="programmed-no">
          {{ 'No' | translate }}
        </label>
      </div>
    </div>
  </div>
  <div *ngIf="programmed" class="form-group"
    [ngClass]="{'has-error':fieldsRequired['programdate']}">
    <label class="control-label col-sm-3">
      {{ 'Programmed Date' | translate }}:
    </label>
    <div class="col-sm-9">
      <app-select-date
        [edittimeflag]="true" (seteditday)="onSelectday($event)">
      </app-select-date>
      <input style="width: unset; display: inline;" class="form-control"
        type="time" name="programtime" [(ngModel)]="programtime"
        (change)="onSelectTime()" required>
    </div>
  </div>
  <div *ngIf="programmed" class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Type of programming' | translate }}:
    </label>
    <div class="col-sm-9">
      <select (change)="onSelectProgramType($event)" class="form-control" [ngModel]="program_type"
        name="program_type" required>
        <option [value]="null">-- {{ 'Select'  | translate }} --</option>
        <option *ngFor="let item of assistance_programming_types" [value]="item.id">
          {{ item.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group">
    <label class="col-sm-3 control-label">
      {{ 'By Connection' | translate }}:
    </label>
    <div class="d-inline col-sm-9 radio-btn-panel">
      <div class="d-inline">
        <input type="radio" [ngModel]="connection" name="connection"
          id="by-connection-yes" (click)="onSelectConnection(1)" [value]=1>
        <label for="by-connection-yes">
          {{ 'Yes' | translate }}
        </label>
      </div>
      <div class="d-inline" *ngIf="!sale_canceled">
        <input type="radio" [ngModel]="connection" name="connection"
          [attr.disabled]="maxAssistancesReached || is_on_waiting_period?
            true: null"
          id="by-connection-no" (click)="onSelectConnection(0)" [value]=0>
        <label for="by-connection-no">
          {{ 'No' | translate }}
        </label>
      </div>
    </div>
    <div
      *ngIf="sale_canceled"
      class="col-sm-12 only-by-connection-notice">
      {{ 'Sale is canceled, only offer by connection' | translate }}
    </div>
    <div
      *ngIf="maxAssistancesReached"
      class="col-sm-12 only-by-connection-notice">
      {{ 'Max assistances reached, only offer by connection' | translate }}
    </div>
    <div
      *ngIf="is_on_waiting_period"
      class="col-sm-12 only-by-connection-notice">
      {{ 'The service is on waiting period, only offer by connection' | translate }}
    </div>
  </div>

   <!-- Vehicle Reference -->
   <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Vehicle Reference' | translate }}:
    </label>
    <div class="col-sm-9">
      <input
        class="form-control" type="text"
        [(ngModel)]="editticket.vehicle_reference" name="vehicle_reference" required>
    </div>

 <div
      *ngIf="intime > 0"
      class="col-sm-12 only-by-connection-notice">
      {{ 'Does not meet the minimum time between services' | translate }}
    </div>

    <div
    *ngIf="in_use > 0"
    class="col-sm-12 only-by-connection-notice">
    {{ 'No more than one active service allowed' | translate }}
      </div> 
    
  </div>
  <div class="form-group">
    <label class="control-label col-sm-3">
      {{ 'Comment' | translate }}:
    </label>
    <div class="col-sm-9">
      <textarea rows="5" cols="10" class="form-control"
        [(ngModel)]="comment" name="comment" required>
      </textarea>
    </div>
  </div>
  <div class="form-group">
  </div>
  <div class="form-group" visible="false">
    <div class="col-sm-offset-3 col-sm-9 div-btn-right">
      <button
        type="submit" class="btn btn-primary btn-sm btn-right"
        [disabled]="parent_form.invalid || parent_form.pending || form.form.invalid || form.form.pending || isDisabled">
        {{ 'Save' | translate }}
      </button>
      <button
        type="button" class="btn btn-default btn-sm btn-right"
        (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
    </div>
  </div>
</form>
